/**
 * @auth:tanqiaofang
 * @time:2018-12-6
 * Element Tabs组件窗口滚动tab栏置顶
 */
function handleScroll(el) {
  var _self =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  var menuTop = document.querySelector('#serchFixed').offsetTop;
  var ItemName = el.querySelector('.el-tabs__nav-scroll');
  //滑动到指定位置菜单吸顶
  if (_self > menuTop) {
    ItemName.classList.add('elFixed');
    el.querySelector('.el-tabs__content').style.padding = '64px 0px 0px';
    const activeItem = el.querySelector('.el-tabs__item.is-active');
    if (!activeItem) return;
    [...el.querySelectorAll('.el-tabs__item')]
      .filter(item => !item.className.includes('is-active'))
      .forEach(item => item.classList.add('activename'));
  } else {
    ItemName.classList.remove('elFixed');
    el.querySelector('.el-tabs__content').style.padding = '';
    [...el.querySelectorAll('.el-tabs__item')]
      .filter(item => !item.className.includes('is-active'))
      .forEach(item => item.classList.remove('activename'));
  }
}
let temp = null;
export default Vue => {
  Vue.directive('scroll', {
    inserted(el) {
      temp = () => handleScroll(el);
      window.addEventListener('scroll', temp);
    },
    unbind() {
      window.removeEventListener('scroll', temp);
    },
  });
};
